module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAABCBAMAAABk96F4AAAAIVBMVEUbRXGnzvqPu+xdlNAWOFujyveVvOl6odBagLJEa54aQWuIduqHAAAAJElEQVQI12MQQIEKDAYMDkC4gIEWwIBBAcmuAIYEhgKGBoYJAOzUBLE8//GaAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/images/gameMain_03_04.png
// module id = 95
// module chunks = 0